///<reference path="../main.js">
/**
 * Copyright 2016 Select Interactive, LLC. All rights reserved.
 * @author: The Select Interactive dev team (www.select-interactive.com) 
 */
var app = {};
///<reference path="main.js">
/**	
 * SI JavaScript library
 *
 * @author Jeremy Burton - jeremy@select-interactive.com
 * @version 0.1.1
 *
 * @description To provide crossbrowser support for Select Interactive
 *   projects without relying on jQuery.
 *   
 * Featured detection and polyfill for
 *   Promises
 *   Fetch
 * 
 * Targeting features such as:
 *   forEach
 *   .matchMedia support
 *   equal height columns
 *   fetch
 */
( function( window, doc, undefined ) {

	// $ - maps to querySelector to return an element
	// @elements - a node list of elements or selector
	// @contenxt - optional - the parent container of the elements. Defaults to document.
	var $ = function( expr, context ) {
		return typeof expr === 'string' ? ( context || doc ).querySelector( expr ) : expr || null;
	};

	// $$ - maps to querySelectorAll to return a node list of elements
	// @expr - the selector expression to search for
	// @contenxt - optional - the parent container of the elements. Defaults to document.
	var $$ = function( expr, context ) {
        return Array.from( typeof expr === 'string' ? ( context || document ).querySelectorAll( expr ) : expr || null );
    };

	// $.addScript - helper function to load scripts
	// @src - String - the source of the script to load
	// @parent - Element - the element that the script should be appended to
	// @async - Boolean - should the script be loaded async
	$.addScript = function( src, parent, async, fn ) {
		var script = doc.createElement( 'script' );
		script.src = src;
		script.async = async;

		if ( fn && typeof fn === 'function' ) {
			script.addEventListener( 'load', () => fn() );
		}

		parent.appendChild( script );
	};

	// if we need to polyfill promises
	if ( typeof self.Promise === 'undefined' || !self.Promise ) {
		$.addScript( '/bower_components/es6-promise/promise.min.js', doc.querySelector( 'head' ), true );
	}

	// If we need to polyfill fetch
	if ( typeof self.fetch === 'undefined' || !self.fetch ) {
		$.addScript( '/bower_components/fetch/fetch.min.js', doc.querySelector( 'head' ), true );
	}

	// $.forEach / window.forEachElement = traverses a node list of elements and executes a function over them
	// @elements - a node list of elements or selector
	// @fn - the function to execute over the list of elements
	// @contenxt - optional - the parent container of the elements. Defaults to document.
	$.forEach = function( elements, fn, context ) {
		var i = 0,
            len;

		if ( !elements || typeof elements === 'function' ) {
			console.log( 'elements is not a valid node list.' );
			return;
		}

		if ( typeof elements === 'string' || elements instanceof String ) {
			elements = $$( elements, context );
		}

		len = elements.length;

		for ( ; i < len; i++ ) {
			if ( fn( elements[i], i ) ) {
				break;
			}
		}
	};

	// keep backwards compatibility for forEachElement
	window.forEachElement = $.forEach;

	// $.addEvent - traverses a node list of elements and attaches and event handler to them
	// @elements - a node list of elements or selector 
	// @evt - the event to watch for (i.e. 'click', 'mouseenter')
	// @fn - the function to execute when the event is raised
	// @contenxt - optional - the parent container of the elements. Defaults to document.
	$.addEvent = function( elements, evt, fn, context ) {
		if ( !elements || typeof elements === 'function' ) {
			console.log( 'elements is not a valid node list.' );
			return;
		}

		if ( typeof elements === 'string' || elements instanceof String ) {
			elements = $$( elements, context );
		}

		$.forEach( elements, function( el ) {
			el.addEventListener( evt, function( e ) {
				fn( e, el );
			}, false );
		} );
	};

	// $.findUp - helper function to recursively traverse up the DOM to find a specified element 
	// @startEl - the element that we start at and move up from
	// @selector - the selector of the element we are looking for
	// @attr - optional - the data attribute of the element we may want a value for
	// @endTag - optional - the selector of the end tag to stop at. Defaults to the body tag.
	// @fn - optional - a function to run once the element has been found
	$.findUp = function( startEl, selector, attr, endTag, fn ) {
		var el = startEl,
			rspObj = {};

		if ( !endTag ) {
			endTag = doc.body;
		}

		function moveUp() {
			if ( $.matches( el, selector ) ) {
				rspObj = {
					el: el,
					val: attr && attr.length ? el.getAttribute( attr ) : ''
				};

				if ( fn ) {
					fn( rspObj );
				}

				return rspObj;
			}
			else {
				el = el.parentNode;

				if ( el === endTag || $.matches( el, endTag ) ) {
					return null;
				}
				else {
					return moveUp();
				}
			}
		}

		return moveUp();
	};

	// $.mq - helper function to check for mediaquery
	// @mediaQuery - the mediaquery to test for (i.e. '(min-width:1024px)')
	$.mq = function( mediaQuery ) {
		return !( window.matchMedia ) || ( window.matchMedia && window.matchMedia( mediaQuery ).matches );
	};

	// keep backwards compatibility for mq
	window.mq = $.mq;

	// $.eqHeight - Helper function to set columns to the same height
	// @context - Optional - Element - the parent element to find rows in. Defaults to body.
	$.eqHeight = function( context ) {
		if ( !context || !context.querySelector ) {
			context = doc;
		}

		// if the promise polyfill hasn't loaded for browsers that need it
		if ( typeof self.Promise === 'undefined' || !self.Promise ) {
			setTimeout( function() {
				$.eqHeight( context );
			}, 10 );

			return;
		}

		// collect all of the rows
		$.forEach( '.eq-height', function( row ) {
			var cols = $$( '.eq-height-item', row ),

				// keep all the image promises as an array
				imagePromises = [];

			// only if we are over a mq of 768px or the row has class .mbl-eq-height
			if ( $.mq( '(min-width:768px)' ) || row.classList.contains( 'mbl-eq-height' ) ) {

				// check if this is large item only
				if ( !row.classList.contains( 'eq-height-item-lg' ) || $.mq( '(min-width:1024px)' ) ) {
					// loop through any images, create a promise for them and add to the imagePromises array
					$.forEach( 'img', function( img ) {
						imagePromises.push( new Promise( function( resolve, reject ) {
							// the image is cached (or has already loaded?)
							if ( img.complete ) {
								resolve( this );
							}
							else {
								// image has loaded
								img.addEventListener( 'load', function() {
									console.log( 'image loaded' );
									resolve( this );
								}, false );
							}
						} ) );
					}, row );

					// if there are images, wait for them to all load before setting the column height
					if ( imagePromises.length ) {
						Promise.all( imagePromises ).then( function() {
							// all images have been loaded
							setColumnHeights( cols );
						}, function() {
							console.warn( 'An image has failed to load.' );
						} );
					}

						// if no images in the container/row, set the column heights now
					else {
						setColumnHeights( cols );
					}
				}
				else {
					$.forEach( cols, function( col ) {
						col.classList.add( 'in' );
					} );
				}
			}
			else {
				$.forEach( cols, function( col ) {
					col.classList.add( 'in' );
				} );
			}
		}, context );

		function setColumnHeights( cols ) {
			var h = 0;

			// find the tallest column
			$.forEach( cols, function( col ) {
				if ( col.offsetHeight > h ) {
					h = col.offsetHeight;
				}
			} );

			// set the height of all the columns to the tallest one
			$.forEach( cols, function( col ) {
				col.style.height = h + 'px';
				col.classList.add( 'in' );
			} );
		}
	};

	// on load let's run eqHeight
	window.addEventListener( 'load', $.eqHeight );

	// $.fetch - Replacing Ajax
	// url - String - the url to fetch
	// options - JSON object - options such as data, method, etc...
	// type - optional - String - the method type. Set to 'GET' to perform a GET request
	$.fetch = function( url, options, type, callbackFn ) {
		var opts, headers;

		// if no url was passed in break now
		if ( !url ) {
			console.warn( 'No url provided to fetch' );
			return;
		}

		// if the promise polyfill hasn't loaded yet
		//   overwrite .then and wait 100 milliseconds then try again.
		if ( typeof self.Promise === 'undefined' || !self.Promise ) {
			return {
				then: function( fn ) {
					setTimeout( () => {
						return $.fetch( url, options, type, fn );
					}, 100 );
				}
			};
		}

		// if the fetch polyfill hasn't loaded yet
		//   overwrite .then and wait 100 milliseconds then try again.
		if ( !self.fetch ) {
			return {
				then: function( fn ) {
					setTimeout( () => {
						return $.fetch( url, options, type, fn );
					}, 100 );
				}
			};
		}
		else {
			// init options to empty object if none were passed in
			if ( !options ) {
				options = {};
			}

			// check fetch request type -- assuming this would a POST request
			if ( !type || type !== 'GET' ) {
				// if additional headers need to be added
				headers = app.util.extend( {
					'Accept': 'application/json',
					'Content-type': 'application/json'
				}, options.headers || {} );

				// setup some default options for a POST request
				//  and extend to include any options that were passed in
				//  specifically the body property for webservice parameters
				opts = app.util.extend( {
					url: url,
					body: '',
					method: 'POST'
				}, options );

				// make sure we include all of the needed headers
				opts.headers = headers;

				// make sure the body property has been stringified
				if ( opts.body && typeof opts.body !== 'string' && opts.body !== {} ) {
					opts.body = JSON.stringify( opts.body );
				}

				// make the fetch call
				return fetch( url, opts ).then( rsp => {
					return rsp.json();
				} ).then( data => {
					if ( callbackFn ) {
						callbackFn( JSON.parse( data.d ) );
					}
					else {
						return data.d;
					}
				} ).then( rsp => {
					return JSON.parse( rsp );
				} );
			}
			else {
				// if additional headers need to be added
				headers = app.util.extend( {
					'Content-Type': 'text/plain'
				}, options.headers || {} );
				
				// setup default options for a GET request
				//  expecting text/plain content type by default
				opts = app.util.extend( {
					method: 'GET'
				}, options );

				// make sure we include all of the needed headers
				opts.headers = headers;

				// make the fetch call
				return fetch( url, opts ).then( function( rsp ) {
					return rsp.text();
				} ).then( function( rsp ) {
					if ( callbackFn ) {
						callbackFn( rsp );
					}
					else {
						return rsp;
					}
				} );
			}
		}
	};

	$.matches = function( elm, selector ) {
		var _matches = ( elm.document || elm.ownerDocument ).querySelectorAll( selector ),
			i = _matches.length;
		while ( --i >= 0 && _matches.item( i ) !== elm ) { }
		return i > -1;
	};

	app.$ = $;
	app.$$ = $$;
}( window, window.document, undefined ) );

// Polyfill for CustomEvent
( function() {

	if ( typeof window.CustomEvent === 'function' ) {
		return false;
	}

	function CustomEvent( event, params ) {
		params = params || { bubbles: false, cancelable: false, detail: undefined };
		var evt = document.createEvent( 'CustomEvent' );
		evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
		return evt;
	}

	CustomEvent.prototype = window.Event.prototype;

	window.CustomEvent = CustomEvent;
} )();

// Avoid 'console' errors in browsers that lack a console
( function() {
	var method;
	var noop = function() { };
	var methods = [
        'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
        'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
        'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
        'timeStamp', 'trace', 'warn'
	];
	var length = methods.length;
	var console = ( window.console = window.console || {} );

	while ( length-- ) {
		method = methods[length];

		// Only stub undefined methods.
		if ( !console[method] ) {
			console[method] = noop;
		}
	}
}() );
///<reference path="../main.js">
/**
 * Copyright 2015 Select Interactive, LLC. All rights reserved.
 * @author: The Select Interactive dev team (www.select-interactive.com) 
 */
 app.util = (function( doc ) {
     'use strict';
       
    // will clone an object, not copying by reference
    function cloneObj( obj ) {
        return JSON.parse( JSON.stringify( obj ) );
    }

    function extend( obj1, obj2 ) {
        var obj = obj1;

        for ( var key in obj2 ) {
            obj[key] = obj2[key];
        }

        return obj;
    }

    function loadScript( url, callback ) {
        if ( typeof self.Promise === 'undefined' || !self.Promise ) {
            return {
                then: fn => polyfillPromises( _ => loadScript( url, fn ) )
            };
        }

        return new Promise(( resolve, reject ) => {
            const script = document.createElement( 'script' );
            script.src = url;
            script.async = true;

            script.onload = _ => {
                resolve( script );

                if ( callback && typeof callback === 'function' ) {
                    callback( script );
                }
            };

            script.onerror = reject;

            document.body.appendChild( script );
        } );
    }

    function preloadImage( url, callback ) {
        if ( typeof self.Promise === 'undefined' || !self.Promise ) {
            return {
                then: fn => polyfillPromises( _ => preloadImage( url, fn ) )
            };
        }

        return new Promise(( resolve, reject ) => {
            const img = new Image();
            img.src = url;
            img.addEventListener( 'onload', _ => resolve() );
            img.addEventListener( 'onerror', _ => reject() );

            if ( callback && typeof callback === 'function' ) {
                console.log( 'not here?' );
                callback();
            }
        } );
    }

    function polyfillPromises( fn ) {
        const script = document.createElement( 'script' );
        script.src = '/bower_components/es6-promise/promise.min.js';
        script.async = true;
        script.onload = fn;
        document.body.appendChild( script ); 
    }

    function polyfillFetch( fn ) {
        const script = document.createElement( 'script' );
        script.src = '/bower_components/fetch/fetch.min.js';
        script.async = true;
        script.onload = fn;
        document.body.appendChild( script );
    }

    function getWindowScrollPosition() {
        if ( typeof window.scrollY === 'undefined' ) {
            return document.documentElement.scrollTop;
        }
        else {
            return window.scrollY;
        }
    }

    function callBackFn( instance, fnName ) {
    	return function() {
    		instance[fnName].apply( instance, arguments );
    	};
    }

    function disableWindowScroll() {
    	doc.body.classList.add( 'noscroll' );
    }

    function enableWindowScroll() {
    	doc.body.classList.remove( 'noscroll' );
    }

    function mq( mediaQuery ) {
        return !( window.matchMedia ) || ( window.matchMedia && window.matchMedia( mediaQuery ).matches );
    } 

    return {
        cloneObj: cloneObj,
        extend: extend,
        loadScript: loadScript,
        preloadImage: preloadImage,
        polyfillPromises: polyfillPromises,
        getWindowScrollPosition: getWindowScrollPosition,
        callBackFn: callBackFn,
        disableWindowScroll: disableWindowScroll,
        enableWindowScroll: enableWindowScroll,
        mq: mq
    };

}( document ) );
/**
* Copyright 2016 Select Interactive, LLC. All rights reserved.
* @author: The Select Interactive dev team (www.select-interactive.com)
*/
( function( doc ) {
    'use strict';

    class SIComponent {
        static attachTo( root ) {
            // Subclasses which extend SIComponent should provide an attachTo() method that takes a root element and
            // returns an instantiated component with its root set to that element.
            return new SIComponent( root );
        }

        static get cssClasses() {
            // Classes extending SIComponent should implement this method to return an object which exports every
            // CSS class the component class needs as a property. e.g. {ACTIVE: 'is-active'}
            return {};
        }

        static get numbers() {
            // Classes extending SIComponent should implement this method to return an object which exports all
            // of its semantic numbers as constants. e.g. {ANIMATION_DELAY_MS: 350}
            return {};
        }

        constructor( root, ...args ) {
            this.root_ = root;
            this.initialize( ...args );
        }

        initialize( /* ...args */ ) {
            // Subclasses can override this to do any additional setup work that would be considered part of a
            // constructor. Any additional arguments besides root will be passed in here.
        }

        // Wrapper method to add an event listener to the component's root element. This is most useful when
        // listening for custom events.
        addEvent( evtType, handler ) {
            this.root_.addEventListener( evtType, handler );
        }

        // Wrapper method to remove an event listener to the component's root element. This is most useful when
        // unlistening for custom events.
        removeEvent( evtType, handler ) {
            this.root_.removeEventListener( evtType, handler );
        }
    }

    app.SIComponent = SIComponent;

}( document ) );
/**
* Copyright 2017 Select Interactive, LLC. All rights reserved.
* @author: The Select Interactive dev team (www.select-interactive.com)
*/
( function( doc ) {
    'use strict';

    const ROOT = 'alert';
    let activeAlert = null;

    class Alert extends app.SIComponent {
        static attachTo( root ) {
            if ( activeAlert ) {
                return activeAlert;
            }

            return new Alert( root );
        }

        static get cssClasses() {
            return {
                ROOT,
                ALERT_ACTIVE: `${ROOT}-is-active`,
                ALERT_EL: `${ROOT}-el`,
                ALERT_HDR: `${ROOT}-header`,
                ALERT_INFO: `${ROOT}-info`,
                BTN: `${ROOT}-btn`,
                BTN_CONFIRM: `${ROOT}-btn-confirm`,
                BTN_CONTAINER: `${ROOT}-btn-container`,
                BTN_DISMISS: `${ROOT}-btn-dismiss,`,
                CONTAINER: `${ROOT}-container`
            };
        }

        static get numbers() {
            return {
                ESCAPE_KEY: 27
            };
        }

        constructor( root, ...args ) {
            super( root, ...args );
        }

        initialize() {
            this.container = this.createAlertElements();
            this.root_.appendChild( this.container );

            this.onConfirm = function() { };
			this.onDismiss = function() { };

            this.addEventListeners();

            activeAlert = this;
        }

        createAlertElements() {
            const el = doc.createElement( 'div' );
            el.classList.add( Alert.cssClasses.CONTAINER );

            this.alertEl = doc.createElement( 'div' );
            this.alertEl.classList.add( Alert.cssClasses.ALERT_EL );

            this.alertHeader = doc.createElement( 'h3' );
            this.alertHeader.classList.add( Alert.cssClasses.ALERT_HDR );

            this.alertInfo = doc.createElement( 'div' );
			this.alertInfo.classList.add( Alert.cssClasses.ALERT_INFO );

            this.btnContainer = doc.createElement( 'div' );
            this.btnContainer.classList.add( Alert.cssClasses.BTN_CONTAINER );

            this.btnDismiss = doc.createElement( 'button' );
            this.btnDismiss.classList.add( Alert.cssClasses.BTN );
            this.btnDismiss.classList.add( Alert.cssClasses.BTN_DISMISS );
            this.btnDismiss.classList.add( 'btn-ripple' );
            this.btnDismiss.textContent = 'Dismiss';

            this.btnConfirm = doc.createElement( 'button' );
            this.btnConfirm.classList.add( Alert.cssClasses.BTN );
            this.btnConfirm.classList.add( Alert.cssClasses.BTN_CONFIRM );
            this.btnConfirm.classList.add( 'btn-ripple' );
            this.btnConfirm.textContent = 'Confirm';

            this.btnContainer.appendChild( this.btnDismiss );
            this.btnContainer.appendChild( this.btnConfirm );

            this.alertEl.appendChild( this.alertHeader );
            this.alertEl.appendChild( this.alertInfo );
            this.alertEl.appendChild( this.btnContainer );

            el.appendChild( this.alertEl );

            return el;
        }

        addEventListeners() {
            this.btnConfirm.addEventListener( 'click', this.onConfirm, false );
			this.btnDismiss.addEventListener( 'click', this.onDismiss, false );
        }

        promptAlert( hdr, content, btnConfirmText, btnDismissText, fnConfirm, fnDismiss ) {
			this.alertHeader.textContent = hdr;
			this.alertInfo.innerHTML = content;
			this.updateButtons( btnConfirmText, btnDismissText, fnConfirm, fnDismiss );
			this.showAlert();

			doc.body.addEventListener( 'keydown', this.handleKeyDown, false );
		}

        updateButtons( btnConfirmText, btnDismissText, fnConfirm, fnDismiss ) {
			this.btnConfirm.textContent = btnConfirmText;
			this.btnDismiss.textContent = btnDismissText;

			this.btnDismiss.MaterialButton = new MaterialButton( this.btnDismiss );
			this.btnConfirm.MaterialButton = new MaterialButton( this.btnConfirm );

			this.btnConfirm.removeEventListener( 'click', this.onConfirm, false );
			this.btnDismiss.removeEventListener( 'click', this.onDismiss, false );

			this.onConfirm = fnConfirm;
			this.onDismiss = fnDismiss;

			this.btnConfirm.addEventListener( 'click', this.onConfirm, false );
			this.btnDismiss.addEventListener( 'click', this.onDismiss, false );
		}

		showAlert() {
			doc.body.classList.add( Alert.cssClasses.ALERT_ACTIVE );
		}

		handleKeyDown( e ) {
			if ( e.keyCode === Alert.numbers.ESCAPE_KEY ) {
				this.onDismiss();
			}
		}

		dismissAlert() {
			doc.body.classList.remove( Alert.cssClasses.ALERT_ACTIVE );
			doc.body.removeEventListener( 'keydown', this.handleKeyPress, false );
		}
    }

    app.Alert = Alert;

}( document ) );
/**
* Copyright 2017 Select Interactive, LLC. All rights reserved.
* @author: The Select Interactive dev team (www.select-interactive.com)
*/
( function( doc ) {
    'use strict';

    const ROOT = 'carousel';

    class Carousel extends app.SIComponent {
        static get cssClasses() {
            return {
                ROOT,
                carousel: `${ROOT}`,
                container: `${ROOT}-container`,
                items: `${ROOT}-item`,
                btns: `${ROOT}-btn`
            };
        }
         
        constructor( root, ...args ) { 
            super( root, ...args );
        }

        initialize() {
            this.carousel = app.$( `.${Carousel.cssClasses.container}` );
            this.items = app.$$( `.${Carousel.cssClasses.items}` );
            this.btns = app.$$( `.${Carousel.cssClasses.btns}` );
            this.last = this.items[this.items.length - 1];

            // TODO: Fix when only 3 items in list?
            if ( this.items.length > 3 ) {
                this.last.classList.add( 'is-ref' );
                this.addEventListeners();
            }
        }

        addEventListeners() {
            this.btns.forEach( btn => {
                btn.addEventListener( 'click', e => { this.navHandler( e ); } );
            } );
        }

        navHandler( e ) {
            let newItem = '';
            let el = document.querySelector( '.is-ref' );
            let currSliderControl = e.target;

            el.classList.remove( 'is-ref' );
            if ( currSliderControl.getAttribute( 'data-toggle' ) === 'next' ) {
                newItem = this.next( el );
                this.carousel.classList.remove( 'is-reversing' );
            } else {
                newItem = this.prev( el );
                this.carousel.classList.add( 'is-reversing' );
            }

            newItem.classList.add( 'is-ref' );
            newItem.style.order = 1;
            for ( let i = 2; i <= this.items.length; i++ ) {
                newItem = this.next( newItem );
                newItem.style.order = i;
            }

            this.carousel.classList.remove( 'is-set' );
            this.slideIt( this.carousel );

        }

        slideIt( el ) {
            setTimeout( function() {
                el.classList.add( 'is-set' );
            }, 50 );
        }

        next( el ) {
            if ( el.nextElementSibling ) {
                return el.nextElementSibling;
            } else {
                return this.carousel.firstElementChild;
            }
        }

        prev( el ) {
            if ( el.previousElementSibling ) {
                return el.previousElementSibling;
            } else {
                return this.carousel.lastElementChild;
            }
        }
    }

    app.$.forEach( `.${Carousel.cssClasses.carousel}`, el => {
        new Carousel( el );
    } );

}( document ) );
/**
* Copyright 2017 Select Interactive, LLC. All rights reserved.
* @author: The Select Interactive dev team (www.select-interactive.com)
*/
( function( doc ) {
    'use strict';

    const ROOT = 'img';

    class FadeIn extends app.SIComponent {
        static attachTo( root ) {
            return new FadeIn( root );
        }

        static get cssClasses() {
            return {
                ROOT,
                FADE_IN: `${ROOT}-fade-in`,
                IS_VISIBLE: `is-visible`,
            };
        }

        constructor( root, ...args ) {
            super( root, ...args );
        }

        initialize() {
            this.imgs = app.$$( `.${FadeIn.cssClasses.FADE_IN}` );
  
            if ( 'IntersectionObserver' in window &&
                'IntersectionObserverEntry' in window &&
                'intersectionRatio' in window.IntersectionObserverEntry.prototype ) {

                if ( !( 'isIntersecting' in window.IntersectionObserverEntry.prototype ) ) {
                    Object.defineProperty( window.IntersectionObserverEntry.prototype,
                        'isIntersecting', {
                            get: function() {
                                return this.intersectionRatio > 0;
                            }
                        } );
                }

                this.initObserver();  
            }
            else {
                // Load IO polyfill
                app.util.loadScript( '/js/app/libs/intersectionObserver.js' )
                    .then( _ => this.initObserver() );
            } 
        }

        initObserver() {
            let threshold = 0.10; 
             
            if ( app.util.mq( '(min-width:1025px)' ) ) {
                threshold = 0.175;
            }

            this.observer = new IntersectionObserver( changes => this.onChange( changes ), {
                rootMargin: '0px',
                threshold: threshold
            } );

            this.imgs.forEach( img => this.observer.observe( img ) );
        } 

        onChange( changes ) {
            changes.forEach( change => {
                if ( change.isIntersecting ) {
                    if ( change.target.getAttribute( 'data-src' ) ) {
                        const img = change.target;
                        const src = img.getAttribute( 'data-src' );

                        app.util.preloadImage( src )
                            .then( _ => {
                                const transitionend = e => {
                                    img.classList.remove( FadeIn.cssClasses.FADE_IN );
                                    img.removeEventListener( 'transitionend', transitionend );
                                };

                                img.addEventListener( 'transitionend', transitionend );
                                img.setAttribute( 'src', src );
                                img.classList.add( FadeIn.cssClasses.IS_VISIBLE );
                            } );
                    }
                    else {
                        change.target.classList.add( FadeIn.cssClasses.IS_VISIBLE );
                    }

                    this.observer.unobserve( change.target );
                }
            } );
        }
    }

    app.FadeIn = FadeIn;

}( document ) );
///<reference path="../main.js">
/**
 * Copyright 2016 Select Interactive, LLC. All rights reserved.
 * @author: The Select Interactive dev team (www.select-interactive.com) 
 * @version: 1.0
 */
( function( doc ) {
	'use strict';

    class Footer {
        constructor() {
            this.btnTop = app.$( '.footer-link-top' );
            this.addEventListeners();
		}

		addEventListeners() {
            this.btnTop.addEventListener( 'click', e => this.scrollUp( e ) );
        }

        scrollUp( e ) {
	        let scrollToTop = window.setInterval( function() {
                let pos = window.pageYOffset;
		        if ( pos > 0 ) {
			        window.scrollTo( 0, pos - 30 );
		        } else {
			        window.clearInterval( scrollToTop );
		        }
            }, 2 );

            e.preventDefault(); 
        }
	}

	if ( app.$( '.footer' ) ) {
		new Footer();
	}

}( document ) );
/**
* Copyright 2016 Select Interactive, LLC. All rights reserved.
* @author: The Select Interactive dev team (www.select-interactive.com)
*/

'use strict';

const config = {
	apiKey: 'AIzaSyA9WItoSzrmPnv_2aQLLc1hv7OrtdwPv9A'
};

class Gmap {
	constructor( el, loadCallback ) {
		// don't create a map twice
		if ( this.initialized ) {
			return;
		}

		this.container = el;
		this.map = null;
		this.markers = [];

		this.loadCallback = loadCallback;

		this.options = {
			defaultCenter: {
                lat: 32.711520,
                lng: -97.413148
			},
			defaultZoom: 11,
			icon: '/img/contact/cs-logo.v1.png',
			scrollwheel: false,
            styles: [{ 'featureType': 'all', 'elementType': 'labels.text.fill', 'stylers': [{ 'saturation': 36 }, { 'color': '#333333' }, { 'lightness': 40 }] }, { 'featureType': 'all', 'elementType': 'labels.text.stroke', 'stylers': [{ 'visibility': 'on' }, { 'color': '#ffffff' }, { 'lightness': 16 }] }, { 'featureType': 'all', 'elementType': 'labels.icon', 'stylers': [{ 'visibility': 'off' }] }, { 'featureType': 'administrative', 'elementType': 'all', 'stylers': [{ 'visibility': 'off' }] }, { 'featureType': 'administrative', 'elementType': 'geometry.fill', 'stylers': [{ 'color': '#fefefe' }, { 'lightness': 20 }] }, { 'featureType': 'administrative', 'elementType': 'geometry.stroke', 'stylers': [{ 'color': '#fefefe' }, { 'lightness': 17 }, { 'weight': 1.2 }] }, { 'featureType': 'landscape', 'elementType': 'geometry', 'stylers': [{ 'lightness': 20 }, { 'color': '#ececec' }] }, { 'featureType': 'landscape.man_made', 'elementType': 'all', 'stylers': [{ 'visibility': 'on' }, { 'color': '#f0f0ef' }] }, { 'featureType': 'landscape.man_made', 'elementType': 'geometry.fill', 'stylers': [{ 'visibility': 'on' }, { 'color': '#f0f0ef' }] }, { 'featureType': 'landscape.man_made', 'elementType': 'geometry.stroke', 'stylers': [{ 'visibility': 'on' }, { 'color': '#d4d4d4' }] }, { 'featureType': 'landscape.natural', 'elementType': 'all', 'stylers': [{ 'visibility': 'on' }, { 'color': '#ececec' }] }, { 'featureType': 'poi', 'elementType': 'all', 'stylers': [{ 'visibility': 'on' }] }, { 'featureType': 'poi', 'elementType': 'geometry', 'stylers': [{ 'lightness': 21 }, { 'visibility': 'off' }] }, { 'featureType': 'poi', 'elementType': 'geometry.fill', 'stylers': [{ 'visibility': 'on' }, { 'color': '#d4d4d4' }] }, { 'featureType': 'poi', 'elementType': 'labels.text.fill', 'stylers': [{ 'color': '#303030' }] }, { 'featureType': 'poi', 'elementType': 'labels.icon', 'stylers': [{ 'saturation': '-100' }] }, { 'featureType': 'poi.attraction', 'elementType': 'all', 'stylers': [{ 'visibility': 'on' }] }, { 'featureType': 'poi.business', 'elementType': 'all', 'stylers': [{ 'visibility': 'on' }] }, { 'featureType': 'poi.government', 'elementType': 'all', 'stylers': [{ 'visibility': 'on' }] }, { 'featureType': 'poi.medical', 'elementType': 'all', 'stylers': [{ 'visibility': 'on' }] }, { 'featureType': 'poi.park', 'elementType': 'all', 'stylers': [{ 'visibility': 'on' }] }, { 'featureType': 'poi.park', 'elementType': 'geometry', 'stylers': [{ 'color': '#dedede' }, { 'lightness': 21 }] }, { 'featureType': 'poi.place_of_worship', 'elementType': 'all', 'stylers': [{ 'visibility': 'on' }] }, { 'featureType': 'poi.school', 'elementType': 'all', 'stylers': [{ 'visibility': 'on' }] }, { 'featureType': 'poi.school', 'elementType': 'geometry.stroke', 'stylers': [{ 'lightness': '-61' }, { 'gamma': '0.00' }, { 'visibility': 'off' }] }, { 'featureType': 'poi.sports_complex', 'elementType': 'all', 'stylers': [{ 'visibility': 'on' }] }, { 'featureType': 'road.highway', 'elementType': 'geometry.fill', 'stylers': [{ 'color': '#ffffff' }, { 'lightness': 17 }] }, { 'featureType': 'road.highway', 'elementType': 'geometry.stroke', 'stylers': [{ 'color': '#ffffff' }, { 'lightness': 29 }, { 'weight': 0.2 }] }, { 'featureType': 'road.arterial', 'elementType': 'geometry', 'stylers': [{ 'color': '#ffffff' }, { 'lightness': 18 }] }, { 'featureType': 'road.local', 'elementType': 'geometry', 'stylers': [{ 'color': '#ffffff' }, { 'lightness': 16 }] }, { 'featureType': 'transit', 'elementType': 'geometry', 'stylers': [{ 'color': '#f2f2f2' }, { 'lightness': 19 }] }, { 'featureType': 'water', 'elementType': 'geometry', 'stylers': [{ 'color': '#dadada' }, { 'lightness': 17 }] }],
			zoomControl: true
		};

		this.initMap = this.initMap.bind( this );
		this.setDefaultCenter = this.setDefaultCenter.bind( this );
		this.setDefaultZoom = this.setDefaultZoom.bind( this );

		this.addScript();
	}

	initMap() {
		this.setDefaultCenter();
		this.setDefaultZoom();

		this.map = new google.maps.Map( this.container, {
			center: this.options.defaultCenter,
			mapTypeControl: false,
			scrollwheel: this.options.scrollwheel,
			streetViewControl: false,
			zoom: this.options.defaultZoom,
			zoomControl: this.options.zoomControl
		} );

		this.map.setOptions( { styles: this.options.styles } );

		if ( this.container.hasAttribute( 'data-map-marker' ) ) {
			let center = this.options.defaultCenter;

			if ( this.container.hasAttribute( 'data-map-marker-position' ) ) {
				let latLng = this.container.getAttribute( 'data-map-marker-position' );
				latLng = latLng.split( ',' );

				center = {
					lat: parseFloat( latLng[0] ),
					lng: parseFloat( latLng[1] )
				};
			}

			this.addMarker( center );
		}

		if ( this.loadCallback && typeof this.loadCallback === 'function' ) {
			this.loadCallback( this.map );
		}
	}

	addScript() {
		app.util.loadScript( 'https://maps.googleapis.com/maps/api/js?key=' + config.apiKey, this.initMap );
	}

	setDefaultCenter() {
		if ( this.container.hasAttribute( 'data-map-center' ) ) {
			const coords = this.container.getAttribute( 'data-map-center' );
			const position = coords.split( ',' );

			if ( position.length ) {
				this.options.defaultCenter = {
					lat: parseFloat( position[0] ),
					lng: parseFloat( position[1] )
				};
			}
		}
	}

	setDefaultZoom() {
		if ( this.container.hasAttribute( 'data-map-zoom' ) ) {
			this.options.defaultZoom = parseInt( this.container.getAttribute( 'data-map-zoom' ), 10 );
		}
	}

	addMarker( data ) {
		const me = this;
		let icon = data.marker || this.options.icon;
			
		let marker = new google.maps.Marker( {
			data: data,
			icon: icon,
			map: this.map,
			position: {
				lat: data.lat,
				lng: data.lng
			}
		} );

		this.markers.push( marker );
    }
}

app.Gmap = Gmap;

class GmapInitializer {
    static init() {

        app.$$( '.gmap-auto' ).forEach( el => {
            new Gmap( el );
        } );
    }
}

if ( app.$( '.gmap' ) ) {
    GmapInitializer.init();
}
/**
 * Copyright 2016 Select Interactive, LLC. All rights reserved.
 * @author: The Select Interactive dev team (www.select-interactive.com) 
 */
( function( doc ) {
    'use strict';

    const ROOT = 'modal';

    class AdminModal extends app.SIComponent {
        static get cssClasses() {
            return {
                ROOT,
                ACTIVE: `${ROOT}-in`,
                BTN_CLOSE: `${ROOT}-close`,
                CONTENT_CONTAINER: `${ROOT}-content`
            };
        }

        constructor( root, ...args ) {
            super( root, ...args );
        }

        initialize() {
            this.close = this.root_.querySelector( '.' + AdminModal.cssClasses.BTN_CLOSE );
            this.content = this.root_.querySelector( '.' + AdminModal.cssClasses.CONTENT_CONTAINER );

            this.show = this.show.bind( this );
            this.hide = this.hide.bind( this );
            this.setContent = this.setContent.bind( this );

            this.addEventListeners();

            return this;
        }

        addEventListeners() {
            this.close.addEventListener( 'click', this.hide, false );
        }

        show() {
            doc.body.classList.add( AdminModal.cssClasses.ACTIVE );
        }

        hide() {
            doc.body.classList.remove( AdminModal.cssClasses.ACTIVE );
        }

        setContent( content ) {
            this.content.innerHTML = content;
        }
    }

    app.AdminModal = AdminModal;

}( document ) );
///<reference path="../main.js">
/**
 * Copyright 2016 Select Interactive, LLC. All rights reserved.
 * @author: The Select Interactive dev team (www.select-interactive.com) 
 * @version: 1.0
 */
( function( doc ) {
	'use strict';

	class Nav {
		constructor() {
            this.url = doc.URL.toLowerCase();
            this.navMain = app.$( '#nav-main' );
            this.navMbl = app.$( '.nav-mbl' );
            this.navActive(); 
            this.addEventListeners();
        }

        addEventListeners() {
            if ( this.navMbl ) {
                this.navMbl.addEventListener( 'click', e => {
                    document.body.classList.toggle( 'mbl-open' );
                } );
            }
        }

        navActive() {
            let navLinks = this.navMain.querySelectorAll( 'a' ); 

            navLinks.forEach( (link, i) => {
                if ( link.href.indexOf( this.url ) !== -1 ) {
                    link.classList.add( 'active' );
                }
            } );
		}
	}

    if ( app.$( '#nav-main' ) ) { 
		new Nav();
	}

}( document ) );
///<reference path="../main.js">
/**
 * Copyright 2016 Select Interactive, LLC. All rights reserved.
 * @author: The Select Interactive dev team (www.select-interactive.com) 
 * @version: 1.0
 */
( function( doc ) {
	'use strict';

	const cssClasses = {
		ANIMATABLE: 'animatable',
		NAV_IN: 'side-nav-in'
	};

	class SideNav {
		constructor() {
			this.btnShow = app.$( '.hdr-nav-trigger' );
			this.sideNav = app.$( '.side-nav' );
			this.sideNavContainer = app.$( '.side-nav-container' );
			this.sideNavClose = app.$( '.side-nav-close' );

			this.showSideNav = this.showSideNav.bind( this );
			this.hideSideNav = this.hideSideNav.bind( this );
			this.onTouchStart = this.onTouchStart.bind( this );
			this.onTouchMove = this.onTouchMove.bind( this );
			this.onTouchEnd = this.onTouchEnd.bind( this );
			this.onTransitionEnd = this.onTransitionEnd.bind( this );
			this.update = this.update.bind( this );

			this.startX = 0;
			this.currentX = 0;
			this.touchingSideNav = false;

			this.addEventListeners();
		}

		addEventListeners() {
			this.btnShow.addEventListener( 'click', this.showSideNav );
			this.sideNav.addEventListener( 'click', this.hideSideNav );
			this.sideNavContainer.addEventListener( 'click', this.blockClicks );
			this.sideNavClose.addEventListener( 'click', this.hideSideNav );
			this.sideNav.addEventListener( 'touchstart', this.onTouchStart );

			this.sideNav.addEventListener( 'touchmove', this.onTouchMove );
			this.sideNav.addEventListener( 'touchend', this.onTouchEnd );
		}

		showSideNav( e ) {
			this.sideNav.classList.add( cssClasses.ANIMATABLE );
			doc.body.classList.add( cssClasses.NAV_IN );
			this.sideNav.addEventListener( 'transitionend', this.onTransitionEnd );
			e.preventDefault();
		}

		hideSideNav( e ) {
			this.sideNav.classList.add( 'animatable' );
			doc.body.classList.remove( cssClasses.NAV_IN );
			this.sideNav.addEventListener( 'transitionend', this.onTransitionEnd );

			if ( e ) {
				e.preventDefault();
			}
		}

		blockClicks( e ) {
			e.stopPropagation();
		}

		onTouchStart( e ) {
			if ( !doc.body.classList.contains( cssClasses.NAV_IN ) ) {
				return;
			}

			this.startX = e.touches[0].pageX;
			this.currentX = this.startX;

			this.touchingSideNav = true;
			requestAnimationFrame( this.update );
		}

		onTouchMove( e ) {
			if ( !this.touchingSideNav ) {
				return;
			}

			this.currentX = e.touches[0].pageX;
			const translateX = Math.min( 0, this.currentX - this.startX );

			if ( translateX < 0 ) {
				e.preventDefault();
			}
		}

		onTouchEnd( e ) {
			if ( !this.touchingSideNav ) {
				return;
			}

			this.touchingSideNav = false;

			const translateX = Math.min( 0, this.currentX - this.startX );
			this.sideNavContainer.style.transform = '';

			if ( translateX < 0 ) {
				this.hideSideNav();
			}
		}

		update() {
			if ( !this.touchingSideNav ) {
				return;
			}

			requestAnimationFrame( this.update );

			const translateX = Math.min( 0, this.currentX - this.startX );
			this.sideNavContainer.style.transform = 'translateX(' + translateX + 'px)';
		}

		onTransitionEnd( e ) {
			this.sideNav.classList.remove( cssClasses.ANIMATABLE );
			this.sideNav.removeEventListener( 'transitionend', this.onTransitionEnd );
		}
	}

	if ( app.$( '.side-nav' ) ) {
		new SideNav();
	}

}( document ) );
/**
* Copyright 2017 Select Interactive, LLC. All rights reserved.
* @author: The Select Interactive dev team (www.select-interactive.com)
*/
( function( doc ) {
    'use strict';

    class Slider extends app.SIComponent {
        static get cssClasses() {
            return {
                wrapper: `home-slides`,
                slide: 'home-slides-slide',
                activeSlide: 'slide-is-active',
                dots: `home-slides-dot`,
                activeDot: `home-slides-dot-is-active`
            };
        }

        static get numbers() {
            return {
                slideDisplayTime: 6000
            };
        }

        constructor( root, ...args ) { 
            super( root, ...args );
        }

        initialize() {
            this.slides = this.root_.querySelectorAll( `.${Slider.cssClasses.slide}` );
            this.dots = this.root_.querySelectorAll( `.${Slider.cssClasses.dots}` );
            this.slides[0].classList.add( Slider.cssClasses.activeSlide );
            this.dots[0].classList.add( Slider.cssClasses.activeDot );
            this.index = 0;
            this.length = this.slides.length;

            this.rotateTimeout = null;

            this.addEventListeners();

            this.rotateTo = this.rotateTo.bind( this );
            this.rotateTimeout = setTimeout( this.rotateTo, Slider.numbers.slideDisplayTime );
        }

        addEventListeners() {
            if ( this.dots && this.dots.length ) {
                app.$.forEach( this.dots, ( dot, i ) => {
                    dot.addEventListener( 'click', e => {
                        this.rotateTo( i );
                        e.preventDefault();
                    } );
                } );
            }
        }

        rotateTo( index ) {
            if ( this.rotateTimeout ) {
                clearTimeout( this.rotateTimeout );
                this.rotateTimeout = null;
            }

            this.slides[this.index].classList.remove( Slider.cssClasses.activeSlide );

            if ( this.dots && this.dots.length ) {
                this.dots[this.index].classList.remove( Slider.cssClasses.activeDot );
            }

            if ( index || index === 0 ) {
                this.index = index;
            }
            else {
                this.index++;

                if ( this.index === this.length ) {
                    this.index = 0;
                }
            }

            const transitionend = e => {
                this.slides[this.index].removeEventListener( 'transitionend', transitionend );
                this.rotateTimeout = setTimeout( this.rotateTo, Slider.numbers.slideDisplayTime );
            };

            this.slides[this.index].addEventListener( 'transitionend', transitionend );

            this.slides[this.index].classList.add( Slider.cssClasses.activeSlide );

            if ( this.dots && this.dots.length ) {
                this.dots[this.index].classList.add( Slider.cssClasses.activeDot );
            }
        }
    }

    app.$.forEach( `.${Slider.cssClasses.wrapper}`, el => {
        new Slider( el );
    } );

}( document ) );
/**
* Copyright 2017 Select Interactive, LLC. All rights reserved.
* @author: The Select Interactive dev team (www.select-interactive.com)
*/
( function( doc ) {
    'use strict';

    const ROOT = 'toast';
    
    class Toast extends app.SIComponent {
        static attachTo( root ) {
            return new Toast( root );
        }

        static get cssClasses() {
            return {
                ROOT,
                VISIBLE: `${ROOT}-is-visible`,
            };
        }

        static get numbers() {
            return {
                DEFAULT_DURATION: 3000
            };
        }

        constructor( root, ...args ) {
            super( root, ...args );
        }

        initialize() {
            this.container = this.createToast();
        }

        show( msg, duration ) {
            this.removeToasts();

            this.container.textContent = msg;
            this.container.classList.add( Toast.cssClasses.VISIBLE );

            this.root_.appendChild( this.container );

            if ( !duration && duration !== -1 ) {
                duration = Toast.numbers.DEFAULT_DURATION;
            }

            if ( duration !== -1 ) {
                setTimeout( _ => this.hide(), duration );
            }
        }

        createToast() {
            const container = doc.createElement( 'div' );
            container.classList.add( Toast.cssClasses.ROOT );
            return container;
        }

        hide() {
            this.container.classList.remove( Toast.cssClasses.VISIBLE );
        }

        removeToasts() {
            const toast = app.$( '.' + Toast.cssClasses.ROOT );
            
            if ( toast ) {
                toast.parentNode.removeChild( toast );
            }
        }
    }

    app.Toast = Toast;

}( document ) );
window.requestAnimationFrame = (function() {
    return  window.requestAnimationFrame       ||
            window.webkitRequestAnimationFrame ||
            window.mozRequestAnimationFrame    ||
            function( callback ){
                window.setTimeout(callback, 1000 / 60);
            };
}());
///<reference path="../main.js">
/**
 * Copyright 2015 Select Interactive, LLC. All rights reserved.
 * @author: The Select Interactive dev team (www.select-interactive.com) 
 * @version: 1.0
 */
( function( doc ) {
	'use strict';

	var MaterialButton = function MaterialButton( element ) {
		this.element_ = element;
		this.init();
	};

	window.MaterialButton = MaterialButton;

	// Definte css classes
	MaterialButton.prototype.cssClasses_ = {
		RIPPLE_BUTTON: 'btn-ripple',
		RIPPLE_CONTAINER: 'btn-ripple-container',
		RIPPLE: 'btn-ripple-element',
		RIPPLE_CENTER: 'btn-ripple-center',
		RIPPLE_IS_ANIMATING: 'is-animating',
		RIPPLE_IS_VISIBLE: 'is-visible'
	};

	MaterialButton.prototype.RippleConstant = {
		INITIAL_SCALE: 'scale(0.0001, 0.0001)',
		INITIAL_SIZE: '1px',
		INITIAL_OPACITY: '0.4',
		FINAL_OPACITY: '0',
		FINAL_SCALE: ''
	};

	// initialize the element
	MaterialButton.prototype.init = function() {
		if ( this.element_ ) {
			
			// if this button needs the ripple effect
			//   add the necessary ripple elements and events
			if ( this.element_.classList.contains( this.cssClasses_.RIPPLE_BUTTON ) ) {
				this.initRipple();
			}
		}
	};

	MaterialButton.prototype.initRipple = function() {
		var recentering;

		// first add the elements
		this.addRippleElements();

		// set defaults and add event handlers
		recentering = this.element_.classList.contains( this.cssClasses_.RIPPLE_CENTER );
		this.frameCount_ = 0;
		this.rippleSize_ = 0;
		this.x_ = 0;
		this.y_ = 0;

		// Touch start produces a compat mouse down event, which would cause a
		// second ripple. To avoid that, we use this property to ignore the first
		// mouse down after a touch start.
		this.ignoringMouseDown_ = false;

		this.boundDownHandler = this.downHandler_.bind( this );
		this.element_.addEventListener( 'mousedown', this.boundDownHandler, false );
		this.element_.addEventListener( 'touchstart', this.boundDownHandler, false );

		this.boundUpHandler = this.upHandler_.bind( this );
		this.element_.addEventListener( 'mouseup', this.boundUpHandler, false );
		this.element_.addEventListener( 'mouseleave', this.boundUpHandler, false );
		this.element_.addEventListener( 'touchend', this.boundUpHandler, false );
		this.element_.addEventListener( 'blur', this.boundUpHandler, false );

		// helpers
		this.getFrameCount = function() {
			return this.frameCount_;
		};

		this.setFrameCount = function( fC ) {
			this.frameCount_ = fC;
		};

		this.getRippleElement = function() {
			return this.rippleElement_;
		};

		this.setRippleXY = function( newX, newY ) {
			this.x_ = newX;
			this.y_ = newY;
		};

		// styles
		this.setRippleStyles = function( start ) {
			if ( this.rippleElement_ !== null ) {
				var transformString, scale, size,
					offset = 'translate(' + this.x_ + 'px, ' + this.y_ + 'px)';

				if ( start ) {
					scale = this.RippleConstant.INITIAL_SCALE;
					size = this.RippleConstant.INITIAL_SIZE;
				}
				else {
					scale = this.RippleConstant.FINAL_SCALE;
					size = this.rippleSize_ + 'px';

					if ( recentering ) {
						offset = 'translate(' + this.boundWidth / 2 + 'px, ' + this.boundHeight / 2 + 'px)';
					}
				}

				transformString = 'translate(-50%, -50%) ' + offset + scale;

				this.rippleElement_.style.webkitTransform = transformString;
				this.rippleElement_.style.msTransform = transformString;
				this.rippleElement_.style.transform = transformString;

				if ( start ) {
					this.rippleElement_.classList.remove( this.cssClasses_.RIPPLE_IS_ANIMATING );
				}
				else {
					this.rippleElement_.classList.add( this.cssClasses_.RIPPLE_IS_ANIMATING );
				}
			}
		};

		// RAF
		this.animFrameHandler = function() {
			if ( this.frameCount_-- > 0 ) {
				requestAnimationFrame( this.animFrameHandler.bind( this ) );
			}
			else {
				this.setRippleStyles( false );
			}
		};
	};

	MaterialButton.prototype.addRippleElements = function() {
		var container = doc.createElement( 'span' );
		container.classList.add( this.cssClasses_.RIPPLE_CONTAINER );

		this.rippleElement_ = doc.createElement( 'span' );
		this.rippleElement_.classList.add( this.cssClasses_.RIPPLE );

		container.appendChild( this.rippleElement_ );

		this.boundRippleBlurHandler = this.blurHandler_.bind( this );
		this.rippleElement_.addEventListener( 'mouseup', this.boundRippleBlurHandler );
		this.element_.appendChild( container );
	};

	// blur event handler
	MaterialButton.prototype.blurHandler_ = function( e ) {
		if ( e ) {
			this.element_.blur();
		}
	};

	// disable the button
	MaterialButton.prototype.disable = function() {
		this.element_.disabled = true;
	};

	// button downHandler
	MaterialButton.prototype.downHandler_ = function( e ) {
		var bound, x, y, clientX, clientY;

		if ( !this.rippleElement_.style.width && !this.rippleElement_.style.height ) {
			var rect = this.element_.getBoundingClientRect();
			this.boundHeight = rect.height;
			this.boundWidth = rect.width;
			this.rippleSize_ = Math.sqrt( rect.width * rect.width + rect.height * rect.height ) * 2 + 2;
			this.rippleElement_.style.width = this.rippleSize_ + 'px';
			this.rippleElement_.style.height = this.rippleSize_ + 'px';
		}

		this.rippleElement_.classList.add( this.cssClasses_.RIPPLE_IS_VISIBLE );

		if ( e.type === 'mousedown' && this.ignoringMouseDown_ ) {
			this.ignoringMouseDown_ = false;
		}
		else {
			if ( e.type === 'touchstart' ) {
				this.ignoringMouseDown_ = true;
			}

			var frameCount = this.getFrameCount();
			if ( frameCount > 0 ) {
				return;
			}

			this.setFrameCount( 1 );

			bound = e.currentTarget.getBoundingClientRect();

			// Check if we are handling a keyboard click.
			if ( e.clientX === 0 && e.clientY === 0 ) {
				x = Math.round( bound.width / 2 );
				y = Math.round( bound.height / 2 );
			} else {
				clientX = e.clientX ? e.clientX : e.touches[0].clientX;
				clientY = e.clientY ? e.clientY : e.touches[0].clientY;
				x = Math.round( clientX - bound.left );
				y = Math.round( clientY - bound.top );
			}

			this.setRippleXY( x, y );
			this.setRippleStyles( true );

			window.requestAnimationFrame( this.animFrameHandler.bind( this ) );
		}
	};

	// button upHandler
	MaterialButton.prototype.upHandler_ = function( e ) {
		// Don't fire for the artificial "mouseup" generated by a double-click.
		if ( e && e.detail !== 2 ) {
			this.rippleElement_.classList.remove( this.cssClasses_.RIPPLE_IS_VISIBLE );
		}

		// Allow a repaint to occur before removing this class, so the animation
		// shows for tap events, which seem to trigger a mouseup too soon after mousedown.
		window.setTimeout( function() {
			this.rippleElement_.classList.remove( this.cssClasses_.RIPPLE_IS_VISIBLE );
		}.bind( this ), 0 );
	};

	// enable the button
	MaterialButton.prototype.enable = function() {
		this.element_.disabled = false;
	};

	app.$.forEach( '.btn-ripple', function( btn ) {
		btn.MaterialButton = new MaterialButton( btn );
	} );
}( document ) );
///<reference path="../main.js">
/**
 * Copyright 2016 Select Interactive, LLC. All rights reserved.
 * @author: The Select Interactive dev team (www.select-interactive.com) 
 */
( function( doc ) {
	'use strict';

	const ckEditorSettings = {
		allowedContent: true,
		height: 350,
		toolbar: 'Simple'
	};

	const formCssClasses = {
		chosenSelect: 'chosen-select',
		ckeditor: 'use-ckeditor',
		errorLabel: 'error-label',
		hidden: 'hidden',
		inputField: 'input-field',
		invalid: 'invalid',
		mediumEditor: 'use-medium-editor',
		required: 'req'
	};

	class Form {
		// When creating a new Form, we can pass in a selected element (i.e. doc.querySelect( '#form' ))
		// or we can pass in a selector (i.e. '#form' )
		constructor( el ) {
			if ( typeof el === 'string' ) {
				el = app.$( el );
			}

			this.container = el;
			this.fields = el.querySelectorAll( 'input:not([type="file"]),textarea,.use-medium-editor,select' );
			this.reqFields = el.querySelectorAll( '.' + formCssClasses.required );
			this.inputFields = el.querySelectorAll( '.' + formCssClasses.inputField + ',.text-editor' );

			this.initFormElements = this.initFormElements.bind( this );
			this.initEditors = this.initEditors.bind( this );
			this.checkActiveInputs = this.checkActiveInputs.bind( this );
			this.validateFields = this.validateFields.bind( this );
			this.collectData = this.collectData.bind( this );
			this.setFieldValues = this.setFieldValues.bind( this );
			this.clearForm = this.clearForm.bind( this );

			this.initFormElements();
			this.initEditors();
		}

		// This function will loop through all input field elements to check for
		// inputs and select elements to create our custom TextBox or Select objects
		initFormElements() {
			app.$.forEach( this.inputFields, container => {
				let select = container.querySelector( 'select' );
				let input = container.querySelector( 'input' );

				if ( select && !select.Select ) {
					select.Select = new app.Select( select );
				}

				if ( !input ) {
					input = container.querySelector( 'textarea' );
				}

				if ( !input ) {
					input = container.querySelector( '.' + formCssClasses.mediumEditor );
				}
				
				if ( input ) {
					let tag = input.tagName.toLowerCase();
					let type = input.type ? input.type.toLowerCase() : '';

					if ( !input.TextBox && type !== 'checkbox' && type !== 'radio' ) {
						let isCKEditor = false;
						let isMediumEditor = false;

						if ( input.classList.contains( formCssClasses.ckeditor ) ) {
							isCKEditor = true;
						}
						else if ( input.classList.contains( formCssClasses.mediumEditor ) ) {
							isMediumEditor = true;
						}

						input.TextBox = new app.TextBox( input, isCKEditor, isMediumEditor );
					}
				}
			} );
		}

		// Helper functions to initialize textareas with MediumEditor or CKEDITOR
		// depending on specified class
		initEditors() {
			app.$.forEach( this.fields, field => {
				if ( field.classList.contains( formCssClasses.mediumEditor ) ) {
					if ( !window.MediumEditor ) {
						console.warn( 'MediumEditor source not found. Unable to use MediumEditor.' );
					}
					else {
						new MediumEditor( field, {
							placeholder: {
								text: ''
							}
						} );
					}
				}
				else if ( field.classList.contains( formCssClasses.ckeditor ) ) {
					if ( !window.CKEDITOR ) {
						console.warn( 'CKEDITOR source not found. Unable to use CKEDITOR' );
					}
					else {
						CKEDITOR.replace( field.id, ckEditorSettings );
						
						if ( field.classList.contains( 'ckfinder' ) ) {
							CKFinder.setupCKEditor( CKEDITOR.instances[field.id], '/ckfinder/' );
						}
					}
				}
			} );
		}

		// Check if inputs/selects have values to set or remove active class
		// on the sibling label
		checkActiveInputs() {
			app.$.forEach( this.inputFields, container => {
				let lbl = container.querySelector( 'label' );
				let select = container.querySelector( 'select' );
				let input = container.querySelector( 'input' );

				if ( lbl ) {
					lbl.classList.remove( 'active' );
				}

				if ( select && select.Select ) {
					select.Select.checkForValue();
				}

				if ( !input ) {
					input = container.querySelector( 'textarea' );
				}

				if ( !input ) {
					input = container.querySelector( '.' + formCssClasses.mediumEditor );
				}

				if ( input && input.TextBox ) {
					input.TextBox.checkForValue();
				}
			} );
		}

		// Helper function to check if required fields have valid data
		validateFields() {
			let isValid = true;

			// changed this loop to use all fields so that we can check
			//   if field level validation is ok.
			app.$.forEach( this.fields, field => {
				let isFieldValid = true;
				let val = '';
				let tag = field.tagName.toLowerCase();

				if ( field.classList.contains( formCssClasses.mediumEditor ) ) {
					val = field.innerText.trim();
					
					if ( field.TextBox ) {
						isFieldValid = field.TextBox.validateField();
					}
					else if ( field.classList.contains( 'req' ) && val === '' ) {
						isFieldValid = false;
					}
				}
				else if ( field.classList.contains( formCssClasses.ckeditor ) ) {
					if ( field.TextBox ) {
						isFieldValid = field.TextBox.validateField();
					}
					else {
						val = CKEDITOR.instances[field.id].getData().trim();

						if ( field.classList.contains( 'req' ) && val === '' ) {
							isFieldValid = false;
						}
					}
				}
				else if ( tag === 'select' ) {
					if ( field.Select ) {
						val = field.Select.getValue();
						isFieldValid = field.Select.checkIfRequired();
					}
					else if ( !field.classList.contains( formCssClasses.chosenSelect ) ) {
						val = field.options[field.selectedIndex].value;
						
						if ( field.classList.contains( 'req' ) && ( val === '' || val === '-1' ) ) {
							isFieldValid = false;
						}
					}
				}
				else {
					if ( field.TextBox ) {
						isFieldValid = field.TextBox.validateField();
					}
					else {
						val = field.value.trim();

						if ( field.classList.contains( 'req' ) && val === '' ) {
							isFieldValid = false;
						}
					}
				}
				
				if ( isValid && !isFieldValid ) {
					isValid = false;
				}

				if ( !isFieldValid ) {
					console.log( 'Invalid Field: ', field );
				}
			} );

			return isValid;
		}

		// Helper function to collect data from form fields and return as
		// JSON key/value pair object. Uses the element's name attribute as the key.
		collectData() {
			let params = {};

			app.$.forEach( this.fields, field => {
				let key = field.getAttribute( 'name' );
				let val = '';
				let tag = field.tagName.toLowerCase();
				let type = field.type ? field.type.toLowerCase() : '';

				if ( type === 'checkbox' ) {
					val = field.checked;
				}
				else if ( field.classList.contains( formCssClasses.mediumEditor ) ) {
					val = field.innerHTML;
				}
				else if ( field.classList.contains( formCssClasses.ckeditor ) ) {
					val = CKEDITOR.instances[field.id].getData().trim();
				}
				else if ( tag === 'select' ) {
					if ( field.Select ) {
						val = field.Select.getValue();
					}
					else if ( !field.classList.contains( formCssClasses.chosenSelect ) ) {
						val = field.options[field.selectedIndex].value;
					}
				}
				else {
					val = field.value.trim();

					if ( field.classList.contains( 'integer' ) ) {
						val = parseInt( val, 10 );
					}
					else if ( field.classList.contains( 'decimal' ) ) {
						val = parseFloat( val );
					}
				}

				if ( key !== null ) {
					params[key] = val;
				}

			} );

			return params;
		}

		// Helper function to set the values of form fields. Will use the 
		// name attribute of each field element to select the respective value
		// from the obj parameter.
		setFieldValues( obj ) {
			app.$.forEach( this.fields, field => {
				let val = obj[field.getAttribute( 'name' )];
				let type = field.type ? field.type.toLowerCase() : '';
				let tag = field.tagName.toLowerCase();

				if ( !obj ) {
					console.warn( 'Property does not exist for key ' + field.getAttribute( 'name' ) );
				}
				else {
					if ( type === 'checkbox' ) {
						field.checked = val;
					}
					else if ( field.classList.contains( formCssClasses.mediumEditor ) ) {
						field.innerHTML = val;
					}
					else if ( field.classList.contains( formCssClasses.ckeditor ) ) {
						val = CKEDITOR.instances[field.id].setData( val );
					}
					else if ( tag === 'select' && field.Select ) {
						field.Select.setValue( val );
					}
					else {
						if ( field.classList.contains( 'input-date' ) ) {
							if ( obj[field.getAttribute( 'name' ) + 'Str'] ) {
								val = obj[field.getAttribute( 'name' ) + 'Str'];
							}
							else {
								val = moment( val ).format( 'MM/DD/YYYY' );
							}
						}

						field.value = val;
					}
				}
			} );

			this.checkActiveInputs();
		}

		// Helper function to clear out the values of a form. Will additionally
		// remove all HTML from containers with class .row-preview and hide
		// all elements with class .btn-item-upload-delete. It will then
		// run checkActiveInputs to reset the labels.
		clearForm() {
			app.$.forEach( this.fields, field => {
				let lbl = field.parentNode.querySelector( '.' + formCssClasses.errorLabel );
				let type = field.type ? field.type.toLowerCase() : '';
				let tag = field.tagName.toLowerCase();

				if ( type === 'checkbox' ) {
					field.checked = false;
				}
				else if ( field.classList.contains( formCssClasses.mediumEditor ) ) {
					field.innerHTML = '';
				}
                else if ( tag === 'textarea' ) {
                    if ( field.classList.contains( formCssClasses.ckeditor ) ) {
                        CKEDITOR.instances[field.id].setData( '' );
                    }
                    else {
                        field.value = '';
                    }
                }
				else if ( tag === 'select' ) {
					if ( field.Select ) {
						field.Select.setValue( '-1' );
					}
					else if ( field.multiple && field.classList.contains( formCssClasses.chosenSelect ) ) {
						app.$.forEach( field.querySelectorAll( 'option' ), function( opt ) {
							opt.selected = false;
						} );

						jQuery( field ).trigger( 'chosen:updated' );
					}
					else {
						field.value = '-1';
					}
				}
				else {
					field.value = '';
				}

				field.classList.remove( formCssClasses.invalid );

				if ( lbl ) {
					field.parentNode.removeChild( lbl );
				}
			} );

			app.$.forEach( '.row-preview', row => {
				row.innerHTML = '';
			}, this.container );

			app.$.forEach( '.btn-item-upload-delete', btn => {
				btn.classList.add( 'hidden' );
			}, this.container );

			this.checkActiveInputs();
		}

		hide() {
			this.container.classList.add( formCssClasses.hidden );
		}

		show() {
			this.checkActiveInputs();
			this.container.classList.remove( formCssClasses.hidden );
		}
	}

	// Expose the Form object to the rest of the project
	app.Form = Form;
}( document ) );
///<reference path="../main.js">
/**
 * Copyright 2016 Select Interactive, LLC. All rights reserved.
 * @author: The Select Interactive dev team (www.select-interactive.com) 
 */
( function( doc ) {
	'use strict';

	const cssClasses = {
		ERROR_LABEL: 'error-label',
		INVALID_REQ_FIELD: 'invalid',
		MD_MENU: 'md-select',
		MENU: 'md-select-menu',
		MENU_OPEN: 'active',
		LIST_ITEM: 'md-select-menu-item',
		LIST_ITEM_HOVER: 'keyover',
		REQUIRED_FIELD: 'req',
		SEARCHBAR: 'md-select-searchbar'
	};

	if ( !String.prototype.startsWith ) {
		String.prototype.startsWith = function( searchString, position ) {
			position = position || 0;
			return this.substr( position, searchString.length ) === searchString;
		};
	}

	class Select {
		constructor( select ) {
			// if on a touch device, default to native select
			if ( 'ontouchstart' in doc.documentElement && app.$.mq( '(max-width:1024px)' ) ) {
				return;
			}

			// elements
			this.select = select;
			this.select.classList.add( cssClasses.MD_MENU );
			this.container = this.select.parentNode;
			this.label = this.container.querySelector( 'label' );
			this.menu = null;
			this.searchBar = null;
			this.searchString = '';

			// if this is a multiple select
			this.multiple = this.select.multiple;

			//
			this.hasSearch = this.select.hasAttribute( 'data-search' );

			this.open = false;
			this.currentIndex = 0;

			this.listItems = [];

			//this.onChange = function() { };

			this.createMenu = this.createMenu.bind( this );
			this.setMenuPosition = this.setMenuPosition.bind( this );
			this.showMenu = this.showMenu.bind( this );
			this.hideMenu = this.hideMenu.bind( this );
			this.changeHandler = this.changeHandler.bind( this );
			this.focusHanlder = this.focusHanlder.bind( this );
			this.blurHandler = this.blurHandler.bind( this );
			this.keyDownHandler = this.keyDownHandler.bind( this );
			this.bodyClickHandler = this.bodyClickHandler.bind( this );
			this.checkIfRequired = this.checkIfRequired.bind( this );

			this.createMenu();
			this.addEventListeners();

		}

		addEventListeners() {
			this.select.addEventListener( 'focus', this.focusHanlder, false );
			this.select.addEventListener( 'blur', this.blurHandler, false );
		}

		// add change event
		setChangeEvent( fn ) {
			this.onChange = fn;
		}

		// create the drop down
		createMenu() {
			let opts = this.select.children;
			let len = opts.length;
			let i;
			let opt;
			let listItem;
			let li;

			this.menu = doc.createElement( 'ul' );
			this.menu.classList.add( cssClasses.MENU );

			this.searchBar = doc.createElement( 'div' );
			this.searchBar.setAttribute( 'contenteditable', 'true' );
			this.searchBar.classList.add( cssClasses.SEARCHBAR );

			// loop through all of the options and create the ListItems
			for ( i = 0; i < len; i++ ) {
				opt = opts[i];

				listItem = new ListItem( opt, i, this );
				this.listItems.push( listItem );
				this.menu.appendChild( listItem.listItem );
			}

			if ( this.select.selectedIndex > 0 && this.listItems[0].dataVal !== '-1' ) {
				this.select.classList.add( 'not-default' );
			}

			doc.body.appendChild( this.menu );

			if ( this.hasSearch ) {
				doc.body.appendChild( this.searchBar );
			}

			this.setMenuPosition();
		}

		// reset the menu
		reloadMenu() {
			let container;

			if ( this.menu ) {
				container = this.menu.parentNode;
				container.removeChild( this.menu );
				this.listItems = [];
				this.createMenu();
			}
		}

		// set the menu position on the page
		setMenuPosition() {
			const rect = this.select.getBoundingClientRect();
			this.menu.style.top = rect.bottom + app.util.getWindowScrollPosition() + 'px';
			this.menu.style.left = rect.left + 'px';
			this.menu.style.width = this.select.offsetWidth + 'px';

			if ( this.hasSearch ) {
				this.searchBar.style.top = ( rect.top + app.util.getWindowScrollPosition() + 10 ) + 'px';
				this.searchBar.style.left = rect.left + 'px';
				this.searchBar.style.width = this.select.offsetWidth + 'px';
			}


		}

		// show the menu
		showMenu() {
			let me = this;

			//Check to see if there is another Select currently open on the document
			if ( doc.Select ) {
				doc.Select.hideMenu();
				doc.Select = null;
			}

			// always start at the top of the list
			this.menu.scrollTop = 0;

			this.currentIndex = -1;
			this.menu.classList.add( cssClasses.MENU_OPEN );
			this.searchBar.classList.add( cssClasses.MENU_OPEN );
			this.searchString = '';
			this.searchBar.innerHTML = '';
			this.open = true;

			setTimeout( function() {
				doc.body.addEventListener( 'keydown', me.keyDownHandler, false );
				doc.body.addEventListener( 'click', me.bodyClickHandler, false );

				me.select.blur();

				let slctdEle = me.menu.querySelector( 'li[selected="true"]' );
				if ( slctdEle ) {

					let menuScrollTop = me.menu.scrollTop;
					let menuHeight = me.menu.offsetHeight;

					if ( slctdEle.offsetTop + slctdEle.offsetHeight > menuScrollTop + menuHeight ) {
						me.menu.scrollTop = slctdEle.offsetTop;// menuScrollTop + slctdEle.offsetHeight;
					}

				}

				me.setHighlighted( 0 );

				if ( me.hasSearch ) {
					me.searchBar.focus();
				}

			}, 100 );



			//Set the current global select so that it can be closed if it is open when another show menu on a different element is pressed.
			doc.Select = this;

			// disable window from scrolling
			app.util.disableWindowScroll();
		}

		// hide the menu
		hideMenu() {
			let item;

			this.menu.classList.remove( cssClasses.MENU_OPEN );

			if ( this.hasSearch ) {
				this.searchBar.classList.remove( cssClasses.MENU_OPEN );
			}

			this.open = false;
			this.searchString = '';

			// make sure no listItems ahve the keyover class
			item = this.menu.querySelector( '.' + cssClasses.LIST_ITEM_HOVER );

			if ( item ) {
				item.classList.remove( cssClasses.LIST_ITEM_HOVER );
			}

			// remove event listeners
			doc.body.removeEventListener( 'keydown', this.keyDownHandler, false );
			doc.body.removeEventListener( 'click', this.bodyClickHandler, false );

			this.filterList();

			// remove the current select from the document.
			doc.Select = null;
			// re-enable window scrolling
			app.util.enableWindowScroll();
		}

		focusHanlder( e ) {
			this.setMenuPosition();
			this.showMenu();
		}

		blurHandler( e ) {
		}

		keyDownHandler( e ) {
			let index = this.currentIndex;
			let keyCode = -1;

			if ( e && e.keyCode ) {
				keyCode = e.keyCode;

				if ( keyCode === 9 ) {
					this.hideMenu();
					this.select.focus();
					//e.preventDefault();
				}

					// move down the list
				else if ( keyCode === 40 ) {
					e.preventDefault();
					this.setHighlighted( 1 );
				}

					// move up the list
				else if ( keyCode === 38 ) {
					e.preventDefault();
					this.setHighlighted( -1 );
				}

					// enter key is clicked
				else if ( keyCode === 13 ) {
					e.preventDefault();

					if ( this.currentIndex === -1 ) {
						this.currentIndex = 0;
					}

					// trigger list item click
					this.listItems[this.currentIndex].selectItem();
				}

					// if escape key is clicked
				else if ( keyCode === 27 ) {
					e.preventDefault();
					this.hideMenu();
				}

					// anyother key is pressed
				else {
					if ( this.hasSearch ) {

						if ( keyCode === 8 ) {
							this.searchString = this.searchString.substr( 0, this.searchString.length - 1 );
						} else {
							if ( e.key.length === 1 && /^[a-zA-Z0-9 _]+$/.test( e.key ) ) {
								this.searchString += e.key;
							}
						}

						this.filterList();

					} else {
						e.preventDefault();
					}

				}
			}
		}

		filterList() {
			if ( this.hasSearch && this.listItems.length > 0 ) {
				let fndCntr = 0;
				let fndItem = null;
				let ul = this.listItems[0].listItem.parentNode;
				ul.classList.add( 'hidden' );
				for ( var i = 0; i < this.listItems.length; i++ ) {
					let thisItem = this.listItems[i].listItem;
					if ( thisItem.innerText.toUpperCase().startsWith( this.searchString.toUpperCase() ) || thisItem.getAttribute( 'selected' ) === 'true' ) {
						thisItem.classList.remove( 'hidden' );

						if ( fndCntr < 2 && thisItem.innerText.toUpperCase().startsWith( this.searchString.toUpperCase() ) ) {
							fndItem = thisItem;
							fndCntr += 1;
						}

					} else {
						thisItem.classList.add( 'hidden' );
					}
				}
				ul.classList.remove( 'hidden' );
				if ( fndCntr === 1 ) {
					fndItem.click();
				}
			}
		}

		setHighlighted( direction ) {
			//Find the selected item and set the current index.  Used upon show menu.
			if ( direction === 0 ) {
				for ( let i = 0; i < this.listItems.length; i++ ) {
					let thisItem = this.listItems[i].listItem;
					if ( thisItem.getAttribute( 'selected' ) === 'true' ) {
						this.currentIndex = i;
						break;
					}
				}
			} else {

				for ( let i = this.currentIndex + direction; i < this.listItems.length && i >= 0 ; i += direction ) {
					let thisItem = this.listItems[i].listItem;
					if ( !thisItem.classList.contains( 'hidden' ) ) {
						if ( this.currentIndex >= 0 ) {
							this.listItems[this.currentIndex].listItem.classList.remove( cssClasses.LIST_ITEM_HOVER );
						}
						this.currentIndex = i;
						thisItem.classList.add( cssClasses.LIST_ITEM_HOVER );

						let menuScrollTop = this.menu.scrollTop;
						let menuHeight = this.menu.offsetHeight;

						if ( direction > 0 ) {
							// check scroll top
							if ( thisItem.offsetTop + thisItem.offsetHeight > menuScrollTop + menuHeight ) {
								this.menu.scrollTop = menuScrollTop + thisItem.offsetHeight;
							}
						} else {
							// check scroll top
							if ( thisItem.offsetTop < menuScrollTop ) {
								this.menu.scrollTop = menuScrollTop - thisItem.offsetHeight;
							}
						}

						break;
					}
				}
			}

		}

		changeHandler( e ) {
			if ( this.onChange && typeof this.onChange === 'function' ) {
				this.onChange();
			}
		}

		bodyClickHandler( e ) {
			if ( e && e.target && ( e.target === this.select || e.target.classList.contains( cssClasses.LIST_ITEM ) || e.target.classList.contains( 'btn-ripple-container' ) || e.target.classList.contains( 'btn-ripple-element' ) || e.target.classList.contains( 'md-select-searchbar' ) ) ) {
				// let the list item click event handle this
			}
			else {
				// clicked outside of the menu, hide the menu
				this.hideMenu();
			}
		}

		checkForValue() {

		}

		checkIfRequired() {
			let isValid = true;
			let selected = this.menu.querySelector( '[selected="true"]' );
			let errorLbl = this.container.querySelector( '.' + cssClasses.ERROR_LABEL );
			let lbl;

			// remove any previous error messages
			if ( errorLbl ) {
				this.container.removeChild( errorLbl );
			}

			// if we don't have a selected option and this is a required field
			if ( ( !selected || selected.getAttribute( 'data-val' ) === '-1' ) && this.select.classList.contains( cssClasses.REQUIRED_FIELD ) ) {
				lbl = doc.createElement( 'span' );
				lbl.classList.add( cssClasses.ERROR_LABEL );
				lbl.textContent = 'Required field.';
				this.container.appendChild( lbl );
				this.select.classList.add( cssClasses.INVALID_REQ_FIELD );
				isValid = false;
			}

				// if we're all good, rmeove the invalid class
			else {
				this.select.classList.remove( cssClasses.INVALID_REQ_FIELD );
			}

			return isValid;
		}

		setValue( value ) {
			let li = this.menu.querySelector( '[data-val="' + value + '"]' );
			let i = 0;
			let len = this.listItems.length;
			let listItem = null;

			if ( li ) {
				for ( i = 0; i < len; i++ ) {
					listItem = this.listItems[i];

					if ( listItem.listItem === li ) {
						if ( !listItem.listItem.getAttribute( 'selected' ) ) {
							listItem.selectItem();
						}
					}
				}
			}
		}

		getValue() {
			if ( !this.multiple ) {
				return this.select.options[this.select.selectedIndex].value;
			}
		}

		getTextValue() {
			if ( !this.multiple ) {
				return this.select.options[this.select.selectedIndex].text;
			}
		}
	}

	class ListItem {
		constructor( opt, index, select ) {
			this.listItem = doc.createElement( 'li' );
			this.select = select;
			this.index = index;
			this.isRequired = select.select.classList.contains( 'req' );
			this.dataVal = opt.value;
			this.isDefault = opt.value === '-1';

			this.listItem.classList.add( cssClasses.LIST_ITEM );
			this.listItem.classList.add( 'btn-ripple' );
			this.listItem.textContent = opt.textContent;
			this.listItem.setAttribute( 'data-val', opt.value );

			if ( this.isDefault ) {
				this.listItem.classList.add( 'default-item' );
			}

			if ( opt.selected ) {
				this.listItem.setAttribute( 'selected', 'true' );
			}

			this.selectItem = this.selectItem.bind( this );

			this.addEventListeners();

			return this;
		}

		addEventListeners() {
			this.listItem.addEventListener( 'click', this.selectItem, false );
		}

		selectItem( e ) {
			let selected;

			// if clicking the currently selected item
			if ( this.listItem.getAttribute( 'selected' ) === 'true' ) {

				if ( !this.isRequired ) {
					this.listItem.removeAttribute( 'selected' );

					if ( !this.select.multiple ) {
						this.select.select.value = '';
					}

					let defaultItem = this.select.select.querySelector( 'option[value="-1"]' );
					if ( defaultItem ) {
						this.select.select.classList.remove( 'not-default' );
						defaultItem.setAttribute( 'selected', 'selected' );
						this.select.select.value = '-1';
					}


					this.select.checkIfRequired();
				} else {
					// hide the menu if this ins not a multiple select
					if ( !this.select.multiple ) {
						this.select.hideMenu();
					}
				}

			}
			else {
				// check if an item is already selected
				selected = this.select.menu.querySelector( '[selected="true"]' );

				// unselect a previously selected item if this is not a multiple select
				if ( selected && !this.select.multiple ) {
					selected.removeAttribute( 'selected' );
				}

				// select the selected item
				this.listItem.setAttribute( 'selected', 'true' );

				// update the selected element
				if ( !this.select.multiple ) {
					this.select.select.value = this.listItem.getAttribute( 'data-val' );
					this.select.checkIfRequired();
				}

				this.select.select.classList.remove( cssClasses.INVALID_REQ_FIELD );

				// hide the menu if this ins not a multiple select
				if ( !this.select.multiple ) {
					this.select.hideMenu();
				}
			}

			if ( this.select.select.value !== '-1' ) {
				this.select.select.classList.add( 'not-default' );
			}

			this.select.changeHandler();

			if ( e ) {
				e.stopPropagation();
			}
		}
	}

	app.Select = Select;

}( document ) );
//<reference path="../main.js">
/**
 * Copyright 2016 Select Interactive, LLC. All rights reserved.
 * @author: The Select Interactive dev team (www.select-interactive.com) 
 * 
 * Corresponding HTML should follow:
 * 
 * <div class="input-field">
 *   <input type="text" id="tb-mytb" name="dbCol" />
 *   <label for="tb-mytb">Label Text</label>
 * </div>
 * 
 * To make a field required, add class="req"
 * To make a field use a datepicker, add class="input-date"
 * 
 * To autovalidate email, set type="email"
 * To auotvalidate phone numbers, set type="tel" 
 */
( function( doc ) {
	'use strict';

	const cssClasses = {
		ACTIVE_FIELD_CLASS: 'active',
		DATE_SELECTOR: 'input-date',
		ERROR_LABEL: 'error-label',
		INVALID_REQ_FIELD: 'invalid',
		REQUIRED_FIELD: 'req'
	};


	// array of reg Expression for validation made up of the following objects
	// {{ type: 'Type or ClassName that indicates test should be applied', regExp: 'Expression to test', msg:'Invalid Msg' },
	const validationTests = [
        { type: 'req', regExp: /^(?!\s*$).+/, msg: 'Required Field' },
        { type: 'email', regExp: /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/, msg: 'Invalid Email Address' },
        { type: 'tel', regExp: /^$|\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/, msg: 'Invalid Phone Number' },
        { type: 'input-date', regExp: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/, msg: 'Invalid Date' },
        { type: 'zip', regExp: /^$|\d{5}(?:[-\s]\d{4})?$/, msg: 'Invalid Zipcode' },
        { type: 'numonly', regExp: /[0-9]$/, msg: 'Numbers Only' },
	];

	class TextBox {
		// Provide the input element for this TextBox
		constructor( input, isCKEditor, isMediumEditor ) {
			// elements
			this.input = input;
			this.container = input.parentNode;
			this.label = this.container.querySelector( 'label' );

			// if this is a ckeditor or mediumeditor
			this.isCKEditor = isCKEditor;
			this.isMediumEditor = isMediumEditor;

			// check for date
			if ( this.input.classList.contains( cssClasses.DATE_SELECTOR ) ) {
				this.initDatePicker();
			}

			// check for initial value
			this.checkForValue();

			this.initDatePicker = this.initDatePicker.bind( this );
			this.focusHandler = this.focusHandler.bind( this );
			this.blurHandler = this.blurHandler.bind( this );
			this.validateField = this.validateField.bind( this );
			this.checkForValue = this.checkForValue.bind( this );
			this.setValue = this.setValue.bind( this );
			this.getValue = this.getValue.bind( this );

			this.addEventListeners();
		}

		// Add the event listeners
		addEventListeners() {
			this.input.addEventListener( 'focus', this.focusHandler, false );
			this.input.addEventListener( 'blur', this.blurHandler, false );
			this.input.addEventListener( 'change', this.checkForValue, false );
		}

		// Initialize the date picker if the input has class .input-date
		initDatePicker() {
			let field = this.input;
			let picker;

			// make sure it is a text input
			field.type = 'text';

			// if touch device use default date picker
			if ( 'ontouchstart' in doc.documentElement ) {
				field.type = 'date';
				return;
			}

			picker = new Pikaday( {
				field: field,
				format: 'MM/DD/YYYY',
				onSelect: function() {
					field.value = this.getMoment().format( 'MM/DD/YYYY' );
				}
			} );
		}

		// OnFocus event handler
		focusHandler() {
			this.label.classList.add( cssClasses.ACTIVE_FIELD_CLASS );
		}

		// OnBlur event handler
		blurHandler() {
			this.checkForValue();
			this.validateField();
		}

		// Helper function to check for a value and handle the active class of the label
		checkForValue() {
			if ( this.getValue() !== '' ) {
				this.label.classList.add( cssClasses.ACTIVE_FIELD_CLASS );

				// DGH - I removed this on 1/25/2017 because it seemed to be validating the field to many times.  Don't think it was necessary since blur and set value already did this.
				//this.validateField();
				//******
			}
			else {
				this.label.classList.remove( cssClasses.ACTIVE_FIELD_CLASS );
			}
		}

		// Helper function to provide validation of field data based on input type and classes
		validateField( compareWithLimit ) {
			let field = this.input;
			let type = field.type ? field.type.toLowerCase() : '';
			let valid = true;
			let val = this.getValue();
			let minChars = field.getAttribute( 'min-chars' );
			let compareWith = field.getAttribute( 'compare-with' );
			let prevError = this.container.querySelector( '.' + cssClasses.ERROR_LABEL );
			let lbl;
			let msg = '';
			let expFound = false;

			if ( minChars && val.length < parseInt( minChars, 10 ) ) {
				valid = false;
				msg = minChars + ' characters required.';
				expFound = true;
			}
			else if ( compareWith ) {
				let compField = document.getElementById( compareWith );
				let compValue = compField.value;
				let thisValue = field.value;

				if ( compValue !== thisValue ) {
					valid = false;
					msg = 'Does Not Match';
					expFound = true;
				}
				else {
					if ( !compareWithLimit ) {
						compField.TextBox.validateField( true );
					}
				}
			}

			if ( !expFound ) {
				//Loop thru validation test to see if any need to be applied.
				for ( var vtCnt = 0; vtCnt < validationTests.length; vtCnt++ ) {
					if ( type === validationTests[vtCnt].type || field.classList.contains( validationTests[vtCnt].type ) ) {
						if ( !validationTests[vtCnt].regExp.test( val ) ) {
							valid = false;
							msg = validationTests[vtCnt].msg;
							break;
						}
					}
				}
			}

			// remove any previous error messages
			if ( prevError ) {
				this.container.removeChild( prevError );
			}

			// if the field is valid
			if ( valid ) {
				field.classList.remove( cssClasses.INVALID_REQ_FIELD );
			}

			// if invalid, make sure it is highlighted
			else {
				field.classList.add( cssClasses.INVALID_REQ_FIELD );

				// if we have a message
				if ( msg !== '' ) {
					lbl = doc.createElement( 'span' );
					lbl.classList.add( cssClasses.ERROR_LABEL );
					lbl.textContent = msg;
					this.container.appendChild( lbl );
				}
			}

			return valid;
		}

		// Helper function to set the value of the input
		setValue( val ) {
			this.input.value = val;
			this.checkForValue();
			this.validateField();
		}

		// Helper function get the value of the input
		getValue() {
			if ( this.isCKEditor ) {
				return CKEDITOR.instances[this.input.id].getData().trim();
			}
			else if ( this.isMediumEditor ) {
				return this.input.innerText.trim();
			}
			
			return this.input.value.trim();
		}
	}

	// Expose the TextBox object to the app
	app.TextBox = TextBox;

}( document ) );
///<reference path="../main.js">
/**
 * Copyright 2015 Select Interactive, LLC. All rights reserved.
 * @author: The Select Interactive dev team (www.select-interactive.com) 
 */
( function( doc ) {
	'use strict';

	if ( 'serviceWorker' in navigator && doc.URL.indexOf( 'localhost' ) === -1 ) {
		navigator.serviceWorker.register( '/serviceworker.js' ).then( registration => {
			console.log( 'serviceworker registration successful with scope: ' + registration.scope );
		} ).catch( err => {
			console.log( 'serviceworker registration failed: ', err );
		} );
	}

}( document ) );